import * as types from "./actionType";

const defaultObj = {
  user: { name: "", email: "" },
  token: null,
  refreshToken: null,
  tokenVerified: false,
  app_id: null,
  guid: null,
  loggingInUser: false,
  loggingUserMessage: null,
  fetchingUserPermissions: false,
  fetchingUserPermissionsStatus: null,
  userPermissions: [],
  additionalInfo: null,
};

const initialState = {
  userProfile: {
    ...defaultObj.user,
  },
  currentUserProfile:null,
  userData: null,
  token: null,
  refreshToken: null,
  loginUserStatus: false,
  loggingInUser: false,
  loggingUserMessage: null,
  fetchingUserPermissions: false,
  fetchingUserPermissionsStatus: null,
  userPermissions: [],
  userAccessLevel: 0,
  userId: null,
  loading: true,
  writePermissions: false,
  loggedInUserData: null,
  forgetPasswordStatus: false,
  setNewPasswordStatus: false,
  resetPasswordStatus: false,
  resetPasswordModelClose: null,
  usertype: null,
};

function authReducer(state = initialState, action) {
  switch (action.type) {
    case types.LOGIN_USER:
      return {
        ...state,
        token: null,
        refreshToken: null,
        loggingInUser: true,
        loggingUserMessage: null,
        loginUserStatus: true,
      };
    case types.LOGIN_USER_SUCCESS: {
      return {
        ...state,
        token: action.payload.accessToken,
        refreshToken: action.payload.refreshToken,
        userData: `${action.payload.user.fName} ${action.payload.user.lName}`,
        guid: action.payload.user.guid,
        loggingInUser: false,
        loggingUserMessage: null,
        loginUserStatus: false,
      };
    }

    case types.LOGIN_USER_FAILED: {
      return {
        ...state,
        token: null,
        refreshToken: null, //added
        loggingInUser: false,
        loggingUserMessage: action.payload.message,
        loginUserStatus: false,
      };
    }

    case types.GET_LOGIN_USERDATA:
      return {
        ...state,
        loggedInUserData: null,
      };
    case types.GET_LOGIN_USERDATA_SUCCESS: {
      return {
        ...state,
        loggedInUserData: action.payload,
      };
    }
    case types.GET_LOGIN_USERDATA_FAILED: {
      return {
        ...state,
        loggedInUserData: null,
      };
    }

    case types.FETCH_USER_PERMISSIONS:
      return {
        ...state,
        fetchingUserPermissions: true,
        fetchingUserPermissionsStatus: null,
        userPermissions: [],
        usertype: null,
      };

    case types.FETCH_USER_PERMISSIONS_SUCCESS:
      return {
        ...state,
        fetchingUserPermissions: false,
        fetchingUserPermissionsStatus: null,
        userPermissions: action.payload,
        userAccessLevel: action.user.accessLevel,
        usertype: action.user.displayName,
      };

    case types.FETCH_USER_PERMISSIONS_FAILED:
      return {
        ...state,
        fetchingUserPermissions: false,
        fetchingUserPermissionsStatus: action.payload,
        userPermissions: [],
        usertype: null,
      };
    case types.FETCH_CURRENT_USER_PROFILE:
      return {
        ...state,
        userProfile: {
          ...defaultObj.user,
        },
        currentUserProfile:null
      };

    case types.FETCH_CURRENT_USER_PROFILE_SUCCESS:
      return {
        ...state,
        userProfile: action.payload,
        currentUserProfile:action.payload
      };

    case types.FETCH_CURRENT_USER_PROFILE_FAILED:
      return {
        ...state,
        userProfile: {
          ...defaultObj.user,
        },
        currentUserProfile:null
      };

    case types.AUTHENTICATE_USER:
      return {
        ...state,
        token: action.payload.accessToken,
        refreshToken: action.payload.refreshToken,
        guid: action.payload.guid,
      };

    case types.LOGOUT_USER:
      return {
        ...state,
        ...initialState,
      };

    case types.FORGOT_PASSWORD:
      return {
        ...state,
        forgetPasswordStatus: true,
        userId: action.payload,
      };

    case types.FORGOT_PASSWORD_SUCCESS:
      return {
        ...state,
        forgetPasswordStatus: false,
        userId: action.payload,
      };

    case types.FORGOT_PASSWORD_FAILED:
      return {
        ...state,
        forgetPasswordStatus: false,
        userId: action.payload,
      };

    case types.SET_NEW_PASSWORD:
      return {
        ...state,
        setNewPasswordStatus: true,
      };

    case types.SET_NEW_PASSWORD_SUCCESS:
      return {
        ...state,
        setNewPasswordStatus: false,
      };

    case types.SET_NEW_PASSWORD_FAILED:
      return {
        ...state,
        setNewPasswordStatus: false,
      };

    case types.HANDLE_PAGE_LOADING:
      return {
        ...state,
        ...action.payload,
      };

    case types.VERIFY_TOKEN:
      return {
        ...state,
        tokenVerified: true,
      };

    case types.VERIFY_TOKEN_SUCCESS:
      return {
        ...state,
        userData: `${action.payload.fName} ${action.payload.lName}`,
        userId: action.payload.guid,
        tokenVerified: false,
      };
    case types.VERIFY_TOKEN_FAILED:
      return {
        ...state,
        tokenVerified: false,
      };

    case types.GENERATE_TOKEN_SUCCESS:
      return {
        ...state,
        token: action.payload.accessToken,
        refreshToken: action.payload.refreshToken,
        tokenVerified: true,
      };
    case types.GENERATE_TOKEN_FAILED:
      return {
        ...state,
        token: null,
        refreshToken: null,
      };

    case types.RESET_PASSWORD:
      return {
        ...state,
        resetPasswordStatus: true,
        resetPasswordModelClose: null,
      };

    case types.RESET_PASSWORD_SUCCESS:
      return {
        ...state,
        resetPasswordStatus: false,
        resetPasswordModelClose: true,
      };

    case types.RESET_PASSWORD_FAILED:
      return {
        ...state,
        resetPasswordStatus: false,
        resetPasswordModelClose: null,
      };

    default:
      return state;
  }
}

export default authReducer;
